// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"1":"c797f51e","45":"e1fa6100","94":"0fdaad5c","265":"38121033","615":"34a15dbb","822":"8ef89dfc"}[chunkId] + ".css";
};